import { isATTVendor, isTMOVendor } from '../util/util';

export const normalizeReferrerUri = (referrerUri = '') =>
  referrerUri
    ?.toString()
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .split(/[/?#]/)[0];

export const filterFixedWirelessProducts = (rawFixedWirelessProducts, fixedWireless) => {
  if (!rawFixedWirelessProducts) {
    return rawFixedWirelessProducts;
  }
  if (fixedWireless && (isATTVendor(fixedWireless.vendor) || isTMOVendor(fixedWireless.vendor))) {
    return rawFixedWirelessProducts.filter((p) =>
      !p.serviceName?.toLowerCase().includes('essentials') &&
      !p.serviceName?.toLowerCase().includes('consumer max')
    );
  }
  return rawFixedWirelessProducts;
};

export const getCurrentTfn = ({
  referrerUri,
  fixedWirelessProducts,
  plans,
  productsWith12MonthFixWirelessServCode,
  isBusinessAddress,
  customTFN,
  fallbackTfn,
}) => {
  const normalizedReferrerUri = normalizeReferrerUri(referrerUri);

  if (normalizedReferrerUri === 'testmyspeed.com') {
    const wiredTfn = '833-608-4862';
    const wirelessTfn = '833-608-4863';
    return fixedWirelessProducts?.length > 0 ? wirelessTfn : wiredTfn;
  }

  const hasPlanUnder100mb = plans?.some(
    (product) => Number(product.downstreamSpd) < 100000,
  );
  const planGreaterThan100 = plans?.some(
    (product) => Number(product.downstreamSpd) > 100000,
  );

  if (
    (productsWith12MonthFixWirelessServCode?.length > 0 && isBusinessAddress) ||
    (productsWith12MonthFixWirelessServCode?.length > 0 && fixedWirelessProducts?.length > 0)
  ) {
    return '833-906-5913';
  }
  if (fixedWirelessProducts?.length > 0 && !(planGreaterThan100 || hasPlanUnder100mb)) {
    return '833-644-2512';
  }
  if (hasPlanUnder100mb) {
    return '833-905-7575';
  }
  if (fixedWirelessProducts?.length > 0 || planGreaterThan100) {
    return '833-905-5435';
  }
  if (customTFN) {
    return customTFN;
  }
  return fallbackTfn;
};
